import { GET_CUSTOMER_SUPPORT } from "../actions/types";

const initState = {
  customer_supports: [],
  loading: false,
};

const customersupportReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_SUPPORT:
      return {
        ...state,
        customer_supports: action.customer_supports,
      };
    case "CUSTOMER_SUPPORT_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default customersupportReducer;
